import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FaqOrgaosPublicos, { type FaqEntry } from './components/FaqOrgaosPublicos';
import { SITE_URL, waLink } from '@/config/site';

const destaques = [
  { icon: 'ri-file-list-3-line', title: 'Documentação fiscal completa', text: 'Nota fiscal, certidões e declarações conforme exigência do processo de compra.' },
  { icon: 'ri-truck-line', title: 'Entrega e montagem', text: 'Equipe própria entrega e monta no endereço da instituição, com conferência no local.' },
  { icon: 'ri-ruler-2-line', title: 'Especificação técnica', text: 'Memorial descritivo, medidas e materiais detalhados para instruir a cotação.' },
  { icon: 'ri-user-star-line', title: 'Interlocução direta', text: 'Atendimento com a direção da empresa, sem intermediários desnecessários.' },
];

const modalidades = [
  {
    icon: 'ri-auction-line',
    title: 'Pregão eletrônico',
    text: 'Participação em disputas eletrônicas com proposta e documentação organizadas dentro do prazo do edital.',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: 'Dispensa de licitação',
    text: 'Atendimento a compras de pequeno valor com cotação formal e documentação completa.',
  },
  {
    icon: 'ri-links-line',
    title: 'Adesão a ata de registro de preços',
    text: 'Fornecimento por adesão, conforme as condições e os limites previstos no instrumento vigente.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Compra direta e contratação privada',
    text: 'Autarquias, fundações, conselhos, escolas e instituições que compram com recursos próprios.',
  },
];

const categorias = [
  { icon: 'ri-armchair-line', title: 'Cadeiras e poltronas', text: 'Operação, atendimento, diretoria, recepção e auditório.', to: '/cadeiras' },
  { icon: 'ri-layout-4-line', title: 'Mesas e estações', text: 'Estações de trabalho, reunião, apoio e refeitório.', to: '/mesas' },
  { icon: 'ri-archive-2-line', title: 'Móveis de aço', text: 'Armários, arquivos, gaveteiros e vestiários.', to: '/aco' },
  { icon: 'ri-school-line', title: 'Mobiliário escolar', text: 'Conjuntos aluno, professor, refeitório e biblioteca.', to: '/escolar' },
  { icon: 'ri-layout-column-line', title: 'Divisórias', text: 'Divisórias modulares e sanitárias para repartições.', to: '/divisorias' },
  { icon: 'ri-volume-mute-line', title: 'Cabines acústicas', text: 'Atendimento sigiloso, reuniões e concentração.', to: '/cabines-acusticas' },
  { icon: 'ri-hotel-bed-line', title: 'Auditórios', text: 'Poltronas e cadeiras para plenários e eventos.', to: '/projetos-corporativos' },
  { icon: 'ri-pencil-ruler-2-line', title: 'Marcenaria sob medida', text: 'Balcões, painéis e mobiliário planejado.', to: '/marcenaria-corporativa' },
  { icon: 'ri-road-map-line', title: 'Mobiliário urbano', text: 'Bancos, bicicletários e lixeiras para praças e parques.', to: '/mobiliario-urbano' },
  { icon: 'ri-restaurant-line', title: 'Praças de alimentação', text: 'Cadeiras, mesas e complementos para áreas coletivas.', to: '/mobiliario-pracas-alimentacao' },
];

const passos = [
  { number: '01', title: 'Envie a demanda', text: 'Informe o órgão, o município, o item e a quantidade estimada. Se houver termo de referência, anexe.' },
  { number: '02', title: 'Especificação técnica', text: 'Nossa equipe confere medidas, materiais e quantitativos e sugere equivalentes quando necessário.' },
  { number: '03', title: 'Proposta formal', text: 'Você recebe a cotação com descrição, prazo de entrega, condições e documentação do fornecimento.' },
  { number: '04', title: 'Entrega e montagem', text: 'Produção, transporte, montagem e conferência no endereço da instituição, com nota fiscal.' },
];

const faq: FaqEntry[] = [
  {
    q: 'A Home Office Premium fornece mobiliário para órgãos públicos?',
    a: 'Sim. Fornecemos móveis corporativos, escolares e institucionais para prefeituras, secretarias, câmaras, autarquias, escolas, conselhos e demais instituições públicas, com emissão de nota fiscal e documentação para o processo de compra.',
  },
  {
    q: 'Vocês participam de pregão eletrônico e dispensa de licitação?',
    a: 'Sim. Atuamos em processos de compra pública conforme a Lei nº 14.133/2021, incluindo pregão eletrônico, dispensa de licitação e adesão a ata de registro de preços, respeitando prazos e condições de cada edital ou instrumento.',
  },
  {
    q: 'É possível receber uma cotação para instruir o termo de referência?',
    a: 'Sim. Elaboramos cotação com descrição técnica, medidas e materiais de cada item, o que ajuda o setor responsável a montar o termo de referência e a pesquisa de preços do processo.',
  },
  {
    q: 'Quais cidades são atendidas?',
    a: 'Estamos em Caruaru, Pernambuco, e atendemos todo o Agreste, a Região Metropolitana do Recife, o Sertão e demais municípios de Pernambuco e estados vizinhos. Para grandes volumes, a entrega é programada conforme o cronograma da instituição.',
  },
  {
    q: 'A entrega e a montagem estão incluídas?',
    a: 'Para Caruaru e cidades da região, entrega e montagem com equipe própria estão incluídas nas condições comerciais. Para localidades mais distantes, o custo de frete e montagem é informado na proposta antes da confirmação.',
  },
  {
    q: 'Quais documentos são fornecidos no fornecimento público?',
    a: 'Nota fiscal, certidões e declarações solicitadas no edital ou no termo de referência, além da descrição técnica dos itens entregues. A documentação é alinhada com o setor de compras da instituição antes do faturamento.',
  },
  {
    q: 'Qual o prazo médio de entrega?',
    a: 'O prazo varia conforme o volume e a disponibilidade das linhas. Normalmente a proposta já traz o prazo em dias úteis, e trabalhamos para cumprir o cronograma definido no contrato ou no empenho.',
  },
  {
    q: 'É preciso ir até o showroom para solicitar cotação?',
    a: 'Não. A cotação pode ser solicitada totalmente à distância, por WhatsApp ou formulário. Para projetos maiores ou compras institucionais, é possível agendar visita técnica ao showroom em Caruaru com hora marcada.',
  },
];

export default function FornecimentoOrgaosPublicosPage() {
  useEffect(() => {
    const breadcrumbId = 'schema-orgaos-publicos-breadcrumb';
    let bcScript = document.getElementById(breadcrumbId) as HTMLScriptElement | null;
    if (!bcScript) {
      bcScript = document.createElement('script');
      bcScript.id = breadcrumbId;
      bcScript.type = 'application/ld+json';
      document.head.appendChild(bcScript);
    }
    bcScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 2, name: 'Fornecimento para órgãos públicos', item: `${SITE_URL}/fornecimento-orgaos-publicos` },
      ],
    });

    const faqId = 'schema-orgaos-publicos-faq';
    let faqScript = document.getElementById(faqId) as HTMLScriptElement | null;
    if (!faqScript) {
      faqScript = document.createElement('script');
      faqScript.id = faqId;
      faqScript.type = 'application/ld+json';
      document.head.appendChild(faqScript);
    }
    faqScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    });

    return () => {
      bcScript?.remove();
      faqScript?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-14 md:pt-16">
        {/* Hero */}
        <section className="bg-white">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10 pt-10 md:pt-16 pb-12 md:pb-16">
            <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-[11.5px] text-foreground-400 mb-7">
              <Link to="/" className="hover:text-foreground-950 transition-colors whitespace-nowrap">Home</Link>
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
              <Link to="/produtos" className="hover:text-foreground-950 transition-colors whitespace-nowrap">Soluções</Link>
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
              <span className="text-foreground-700 whitespace-nowrap">Órgãos Públicos</span>
            </nav>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center">
              <div className="lg:col-span-5">
                <p className="hop-eyebrow text-foreground-400">Fornecimento institucional</p>

                <h1 className="mt-5 text-[32px] sm:text-[42px] md:text-[50px] leading-[1.06] tracking-[-0.038em] font-semibold text-foreground-950">
                  Mobiliário para órgãos públicos, com documentação e prazo.
                </h1>

                <p className="mt-5 text-[15px] md:text-[16.5px] leading-[1.6] text-foreground-500 max-w-[520px]">
                  Cadeiras, mesas, armários, divisórias, poltronas de auditório e mobiliário escolar
                  para prefeituras, secretarias, câmaras, autarquias e escolas de Pernambuco.
                </p>

                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <Link
                    to="/orcamento?perfil=orgao"
                    className="inline-flex items-center justify-center bg-foreground-950 text-white text-[14px] md:text-[15px] font-medium px-7 py-3.5 rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Solicitar cotação institucional
                  </Link>
                  <a
                    href={waLink('orgaoPublico')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 border border-background-300 text-foreground-800 text-[14px] md:text-[15px] font-medium px-7 py-3.5 rounded-full hover:border-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    WhatsApp comercial
                  </a>
                </div>

                <p className="mt-6 text-[12px] text-foreground-400 leading-relaxed max-w-[440px]">
                  Atendemos pregão eletrônico, dispensa de licitação, adesão a ata de registro de preços
                  e compra direta. Não prestamos consultoria em licitações — apenas o fornecimento do mobiliário.
                </p>
              </div>

              <div className="lg:col-span-7">
                <div className="w-full h-[260px] sm:h-[340px] lg:h-[440px] rounded-[18px] md:rounded-[24px] overflow-hidden bg-background-100">
                  <img
                    src="/media/ia/0195.webp"
                    alt="Mobiliário institucional fornecido para órgãos públicos — estações de trabalho, cadeiras e armários"
                    title="Mobiliário para prefeituras e secretarias — HomeOffice Premium"
                    className="w-full h-full object-cover object-center"
                    fetchPriority="high"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Destaques — faixa discreta */}
        <section className="border-y border-background-200 bg-background-50">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
              {destaques.map((item, index) => (
                <div
                  key={item.title}
                  className={`py-6 md:py-8 ${
                    index > 0 ? 'border-t sm:border-t-0 sm:border-l border-background-200 sm:pl-6 lg:pl-8' : 'sm:pr-6 lg:pr-8'
                  }`}
                >
                  <i className={`${item.icon} text-[17px] text-primary-600`}></i>
                  <h2 className="mt-3 text-[14px] md:text-[15px] font-medium text-foreground-950 tracking-[-0.02em]">
                    {item.title}
                  </h2>
                  <p className="mt-1.5 text-[12.5px] text-foreground-500 leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Modalidades */}
        <section className="hop-section bg-white">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="max-w-[620px]">
              <p className="hop-eyebrow text-foreground-400">Modalidades</p>
              <h2 className="mt-4 text-[26px] sm:text-[32px] md:text-[40px] leading-[1.08] tracking-[-0.035em] font-semibold text-foreground-950">
                Como a instituição pode comprar.
              </h2>
              <p className="mt-4 text-[14.5px] md:text-[15.5px] leading-[1.6] text-foreground-500">
                Adequamos a proposta ao formato de contratação utilizado pelo órgão, conforme a Lei nº 14.133/2021.
              </p>
            </div>

            <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 border-t border-background-200">
              {modalidades.map((modalidade, index) => (
                <div
                  key={modalidade.title}
                  className={`flex items-start gap-4 py-6 md:py-7 border-b border-background-200 ${
                    index % 2 === 0 ? 'md:pr-10 md:border-r' : 'md:pl-10'
                  }`}
                >
                  <i className={`${modalidade.icon} text-[17px] text-foreground-400 mt-1`}></i>
                  <div>
                    <h3 className="text-[15px] md:text-[16px] font-medium text-foreground-950 tracking-[-0.02em]">
                      {modalidade.title}
                    </h3>
                    <p className="mt-1.5 text-[13px] text-foreground-500 leading-relaxed">{modalidade.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categorias */}
        <section className="hop-section bg-background-50">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div className="max-w-[520px]">
                <p className="hop-eyebrow text-foreground-400">Categorias</p>
                <h2 className="mt-4 text-[26px] sm:text-[32px] md:text-[40px] leading-[1.08] tracking-[-0.035em] font-semibold text-foreground-950">
                  O que fornecemos.
                </h2>
              </div>
              <p className="text-[13px] text-foreground-400 max-w-[320px] leading-relaxed">
                Itens padronizados e sob medida, com especificação técnica para instruir o processo de compra.
              </p>
            </div>

            <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 border-t border-background-200">
              {categorias.map((cat) => (
                <Link
                  key={cat.title}
                  to={cat.to}
                  className="group flex flex-col py-6 border-b border-background-200 cursor-pointer"
                >
                  <div className="flex items-center justify-between gap-3">
                    <i className={`${cat.icon} text-[17px] text-foreground-400 group-hover:text-primary-600 transition-colors`}></i>
                    <i className="ri-arrow-right-up-line text-[13px] text-foreground-300 group-hover:text-primary-600 transition-colors"></i>
                  </div>
                  <h3 className="mt-4 text-[15px] font-medium text-foreground-950 tracking-[-0.02em]">{cat.title}</h3>
                  <p className="mt-1.5 text-[12.5px] text-foreground-500 leading-relaxed">{cat.text}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Processo */}
        <section className="hop-section bg-white">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
              <div className="lg:col-span-5">
                <p className="hop-eyebrow text-foreground-400">Processo</p>
                <h2 className="mt-4 text-[26px] sm:text-[32px] md:text-[40px] leading-[1.08] tracking-[-0.035em] font-semibold text-foreground-950">
                  Da demanda à entrega.
                </h2>
                <p className="mt-4 text-[14.5px] md:text-[15.5px] leading-[1.6] text-foreground-500 max-w-[420px]">
                  Um caminho simples, pensado para o ritmo do setor público — sem idas e vindas desnecessárias.
                </p>
                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <a
                    href={waLink('orgaoPublico')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-foreground-950 text-white text-[14px] font-medium px-6 py-3 rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    Falar com a equipe
                  </a>
                  <Link
                    to="/catalogo"
                    className="inline-flex items-center justify-center border border-background-300 text-foreground-800 text-[14px] font-medium px-6 py-3 rounded-full hover:border-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Ver catálogo
                  </Link>
                </div>
              </div>

              <div className="lg:col-span-7">
                <div className="border-t border-background-200">
                  {passos.map((passo) => (
                    <div key={passo.number} className="flex items-start gap-5 py-6 border-b border-background-200">
                      <span className="text-[11px] font-medium tracking-[0.14em] text-foreground-300 pt-1 w-7 flex-shrink-0">
                        {passo.number}
                      </span>
                      <div>
                        <h3 className="text-[15px] md:text-[16px] font-medium text-foreground-950 tracking-[-0.02em]">
                          {passo.title}
                        </h3>
                        <p className="mt-1.5 text-[13px] text-foreground-500 leading-relaxed max-w-[460px]">{passo.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="hop-section bg-background-50 border-t border-background-200">
          <div className="max-w-[900px] mx-auto px-5 md:px-8">
            <div className="max-w-[620px]">
              <p className="hop-eyebrow text-foreground-400">Dúvidas frequentes</p>
              <h2 className="mt-4 text-[26px] sm:text-[32px] md:text-[38px] leading-[1.08] tracking-[-0.035em] font-semibold text-foreground-950">
                Perguntas de gestores e pregoeiros.
              </h2>
            </div>
            <div className="mt-8">
              <FaqOrgaosPublicos items={faq} />
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="pb-20 md:pb-28 pt-4">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="rounded-[20px] md:rounded-[28px] bg-background-950 px-6 sm:px-10 md:px-16 py-12 md:py-16 text-center">
              <h2 className="text-[26px] sm:text-[32px] md:text-[40px] leading-[1.1] tracking-[-0.038em] font-semibold text-white max-w-[620px] mx-auto">
                Precisa de uma cotação para a sua instituição?
              </h2>
              <p className="mt-4 text-[14px] md:text-[15px] text-white/55 max-w-[480px] mx-auto leading-relaxed">
                Envie a lista de itens, quantidades e o município. Retornamos com a proposta técnica e comercial.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href={waLink('orgaoPublico')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-white text-foreground-950 text-[14px] font-medium px-7 py-3.5 rounded-full hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Solicitar no WhatsApp
                </a>
                <Link
                  to="/orcamento?perfil=orgao"
                  className="inline-flex items-center justify-center gap-2 border border-white/20 text-white text-[14px] font-medium px-7 py-3.5 rounded-full hover:border-white/50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Formulário de cotação
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}